<template>
  <div class="registration-container">
    <div class="registration-card">
      <div class="registration-header">
        <h1 class="registration-title">Create Account</h1>
        <p class="registration-subtitle">Start your timeline journey today</p>
      </div>

      <form class="registration-form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label for="inputEmail" class="form-label">Email Address</label>
          <div class="input-wrapper">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <input
              type="email"
              id="inputEmail"
              class="form-input"
              placeholder="Enter your email"
              required
              autofocus
              v-model="email"
            >
          </div>
        </div>

        <div class="form-group">
          <label for="inputPassword" class="form-label">Password</label>
          <div class="input-wrapper password-wrapper">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <input
              :type="showPassword ? 'text' : 'password'"
              id="inputPassword"
              class="form-input password-input"
              placeholder="Create a password"
              required
              v-model="password"
            >
            <button
              type="button"
              class="password-toggle"
              :aria-label="showPassword ? 'Hide password' : 'Show password'"
              @click="togglePasswordVisibility"
            >
              <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 9.9A3 3 0 0 1 14.1 14.1"></path>
                <path d="M1 1l22 22"></path>
              </svg>
            </button>
          </div>
        </div>

        <button class="btn-signup" type="submit">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          Start Timeline
        </button>

        <div class="divider">
          <span>or</span>
        </div>

        <p class="login-prompt">
          Already have an account?
          <router-link to="/login" class="link-login">Log In</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  // import axios from '../axios-auth'; // Don't have to name it axios, can name it anything - Lecture 348

  export default {
    data () {
      return {
        email: '',
        password: '',
        showPassword: false,

        teams: [],
        teamSelection: '',

        aakashid: null,
      }
    },
    created() {
      this.teams = this.$store.getters.teams
    },
    methods: {
      togglePasswordVisibility () {
        this.showPassword = !this.showPassword
      },
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/optimum/create-candidate/', {
        //   email: formData.email,
        //   password: formData.password,
        //   // returnSecureToken: true,
        //   agency: 2,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))

        // https://vuex.vuejs.org/guide/actions.html
        // Once the user has been registered then we log them in
        // this.$store.dispatch('registerCandidate', {email: this.email, password: this.password}).then(() => {
        // this.$store.dispatch('registerUser', {email: this.email, password: this.password, user_type: 'candidate', team: 'myrundash'}).then(() => {
        this.$store.dispatch('registerUser', {email: this.email, password: this.password, user_type: 'candidate', team: this.teamSelection }).then(() => {
          // this.$store.dispatch('testAction')
          // this.$store.dispatch('login', {email: this.email, password: this.password}).then(() => {
          //   this.$store.dispatch('getUser')
          // })
          console.log('Done registration')

          // // Get the id of the aakashkgoel@gmail.com user
          // // this is necessary because the user changes depending on whether we are using the dev or production database
          // axios.get('/api/users/?email=aakashkgoel@gmail.com')
          //   .then(res => {
          //     console.log('Getting aakashid')
          //     console.log(res)
          //     console.log(res.data)
          //     console.log(res.data[0].id)
          //     this.aakashid = res.data[0].id

          //     // Send myself an email notification that a new candidate registered
          //     this.$store.dispatch('sendEmail',
          //       {
          //         subject: 'New MyRunDash Reg',
          //         message: 'Email: '+this.email+'\nTeam: '+this.team,
          //         from: 'info@myrundash.com',
          //         email: 'aakashkgoel@gmail.com',
          //         reply: 'aakashkgoel@gmail.com',
          //         userID: this.aakashid,
          //       }
          //     )
          //   })
          //   .catch(error => console.log(error))

          this.$store.dispatch('sendEmail', { subject: 'New Timeline Registration!',
                                              message: 'A new runner has just registered!\nTheir email is: '+this.email+'\nTheir team is: '+this.teamSelection,
                                              from: 'myrundash@gmail.com',
                                              email: 'aakashkgoel@gmail.com',
                                              reply: 'aakashkgoel@gmail.com',
                                              userID: 1})
          // if (this.teamSelection == 'MDI') {
          //   this.$store.dispatch('sendEmail', { subject: 'New MDI Runner Registration!',
          //                                     message: 'Hi Coach, a new runner has just registered!\nTheir email is: '+this.email,
          //                                     from: 'myrundash@gmail.com',
          //                                     email: 'kevinsmith@marathondynamics.com',
          //                                     // email: 'aakashkgoel@gmail.com',
          //                                     reply: 'aakashkgoel@gmail.com',
          //                                     userID: 1})
          // }

        })
      },
      // demoLogin() {
      //   this.$store.dispatch('login', {email: 'myrundash@gmail.com', password: 'myrundash'})
      //     .then(() => {
      //       console.log('Successful demo login!')
      //       // console.log(axios.defaults.baseURL)
      //     })
      //     .catch(error => {
      //       console.log('problemoo logging into demo')
      //       // this.loginError = true
      //     })
      // },
    }
  }
</script>

<style scoped>
.registration-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.registration-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px;
  width: 100%;
  max-width: 440px;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.registration-header {
  text-align: center;
  margin-bottom: 40px;
}

.registration-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.registration-subtitle {
  font-size: 16px;
  color: #718096;
  margin: 0;
  font-weight: 400;
}

.registration-form {
  width: 100%;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: #a0aec0;
  pointer-events: none;
  transition: color 0.3s ease;
}

.form-input {
  width: 100%;
  padding: 14px 16px 14px 48px;
  font-size: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  outline: none;
  transition: all 0.3s ease;
  background-color: #f7fafc;
  color: #2d3748;
}

.password-input {
  padding-right: 48px;
}

.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #4a5568;
}

.form-input::placeholder {
  color: #a0aec0;
}

.form-input:focus {
  border-color: #667eea;
  background-color: white;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.form-input:focus + .input-icon,
.input-wrapper:focus-within .input-icon {
  color: #667eea;
}

.btn-signup {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn-signup svg {
  flex-shrink: 0;
}

.btn-signup:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.btn-signup:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.divider {
  position: relative;
  text-align: center;
  margin: 32px 0;
}

.divider::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
  background-color: #e2e8f0;
}

.divider span {
  position: relative;
  display: inline-block;
  padding: 0 16px;
  background-color: white;
  color: #a0aec0;
  font-size: 14px;
  font-weight: 500;
}

.login-prompt {
  text-align: center;
  font-size: 15px;
  color: #4a5568;
  margin: 0;
}

.link-login {
  color: #667eea;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
}

.link-login:hover {
  color: #764ba2;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .registration-container {
    padding: 16px;
    background: white;
  }

  .registration-card {
    padding: 32px 24px;
    box-shadow: none;
    border-radius: 0;
  }

  .registration-title {
    font-size: 28px;
  }

  .registration-subtitle {
    font-size: 14px;
  }

  .form-input {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .registration-card {
    padding: 24px 20px;
  }

  .registration-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Registration.vue